import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { genBillPdfApiModel } from 'src/app/core/models/about-court-fee/about-court-fees';
import { FileModel } from 'src/app/core/models/shared/file.model';
import { AboutCourtFeesService } from 'src/app/core/services/about-court-fees/about-court-frees.service';
import { ViewSDKClient } from 'src/app/core/services/viewSDKClient.service';

@Component({
  selector: 'app-payment-bill',
  templateUrl: './payment-bill.component.html',
  styleUrls: ['./payment-bill.component.scss']
})
export class PaymentBillComponent implements OnInit {

  caseId:number =0
  billId:number =0
  fileUrl:genBillPdfApiModel = new genBillPdfApiModel
  constructor(
    private route:ActivatedRoute,
    private viewSDKClient: ViewSDKClient,
    private aboutCourtFeesService:AboutCourtFeesService

  ) {
    this.route.params.subscribe((params: any) => {
      console.log('parms:',params)
      this.caseId = params.caseId
      this.billId = params.billId

    })
   }

  ngOnInit(): void {
    this.getData()
  }

  async getData() {
    this.fileUrl = await this.aboutCourtFeesService.genBillPdf(this.caseId,this.billId);
    // this.renderPDf()
    }

  renderPDf() {
    this.viewSDKClient.ready().then(() => {
      /* Invoke file preview */
      const canvas: any = document.querySelector('#pdf-div');
      canvas.style.display = "block";
      canvas.style.height = "100vh";
      let defConfg = {
        showAnnotationTools: false, 
        showPageControls: true, 
        showDownloadPDF: true, 
        showPrintPDF: true

      }
      this.viewSDKClient.previewFile('pdf-div', defConfg,this.fileUrl.url,'');
    });
  }

}
